import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=11131f9e&"
import script from "./PdfViewer.vue?vue&type=script&lang=js&"
export * from "./PdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=11131f9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QFab from 'quasar/src/components/fab/QFab.js';
import QFabAction from 'quasar/src/components/fab/QFabAction.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QFab,QFabAction});
